export class Image {
    idFoto: number;
    path: string;
    archivo: string;
    idReparacionDetalle: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/image.ts